import React from "react";
import strapi from "scripts/strapi/index.js";
import ResourcesLayout from "layouts/resources";


export default function ArticlesPage({articles}) {
  return <ResourcesLayout
    articles={articles}
    title="Case Studies | Deviate Labs"
    description="The official Deviate Labs' collection of case studies. Learn about our work with clients and how we helped them grow their businesses. We specialize in growth marketing, growth hacking, and digital marketing."
    headline="Growth Marketing Case Studies"
    subheadline="The official collection of Deviate Labs' case studies, featuring real growth results from real clients. "
  />;
}


export async function getStaticProps() {
  let data = await strapi.article.findMany({
    filters: {
      category: "Case Study",
    },
    populate: {
      coverArt: "*",
    },
    fields: [ //don't include the body since it's large and unnecessary
      "headline",
      "slug",
      "teaser",
      "priority",
      "category",
      "publishedAt",
    ],
  });

  return {
    props: {
      articles: data,
    },
    revalidate: 60,
  };
}
